// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"187":"21aeb38e","453":"95f0797f","742":"e53a731c","945":"c3677457"}[chunkId] + ".chunk.js";
};